import { useLazyQuery } from '@apollo/client';
import { useCallback } from 'react';

import { getVisitorCustomFieldConfigs } from 'graphql-queries';
import type {
  GetVisitorCustomFieldConfigsQuery,
  GetVisitorCustomFieldConfigsQueryVariables,
} from 'graphql-query-contracts';

const EMPTY_CUSTOM_FIELD_CONFIGS: GetVisitorCustomFieldConfigsQuery['visitorCustomFieldConfigs'] = [];

export const useVisitorCustomFieldConfigs = () => {
  const [fetchConfigs, { data, loading, error, called }] = useLazyQuery<
    GetVisitorCustomFieldConfigsQuery,
    GetVisitorCustomFieldConfigsQueryVariables
  >(getVisitorCustomFieldConfigs,
    {
      fetchPolicy: 'network-only',
      notifyOnNetworkStatusChange: true,
    }
  );

  const fetch = useCallback(
    (organizationId: string) => {
      if (!organizationId) return;

      fetchConfigs({ variables: { organizationId } });
    },
    [fetchConfigs]
  );

  return {
    data: data?.visitorCustomFieldConfigs ?? EMPTY_CUSTOM_FIELD_CONFIGS,
    loading,
    error,
    called,
    fetch,
  };
};
